import React from 'react'
import { DatePicker as BaseDatePicker } from 'app/theme/date-picker'
import { Calendar } from 'react-feather'

const theme = {
  div: null,
  label: 'label block mb-2',
  input: 'input-basic cursor-pointer',
  error: 'text-sm text-red-600 mt-1',
}

export default function DatePicker(props) {
  const {
    value,
    timePicker,
    className,
    classNames,
    divProps,
    label,
    labelProps,
    error,
    errorProps,
    icon,
    ...inputProps
  } = props

  const styles = { ...theme, ...classNames }

  return (
    <div className={styles.div} {...divProps}>
      {label && (
        <label className={styles.label} {...labelProps}>
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {icon !== false && (
          <Calendar
            size={20}
            className="absolute right-0 mr-3 text-gray-600 pointer-events-none"
          />
        )}
        <div className="flex-1">
          <BaseDatePicker
            {...inputProps}
            timePicker={timePicker}
            className={[styles.input, icon && 'pr-10']}
            date={value}
          />
        </div>
      </div>
      {error && (
        <div className={styles.error}>
          {error}
        </div>
      )}
    </div>
  )
}
